module.exports = __webpack_public_path__ + "img/1c.f7db11a8.svg";